import { getCategoryDetails } from "./";
import { getQuery } from "../../search/domains/filters/selectors/getAllAppliedRefinements";
import getMatchedSeoImportantFacet from "../../../../helpers/getMatchedSeoImportantFacet";

const hasNonEmptyHeaderBody = headerBody => Boolean(headerBody?.trim());

export default state => {
  const categoryDetails = getCategoryDetails(state);
  const { refine } = getQuery(state);
  const matchedSeoImportantFacet = getMatchedSeoImportantFacet({
    seoImportantFacets: categoryDetails?.seoImportantFacets,
    refine
  });

  if (matchedSeoImportantFacet) {
    return hasNonEmptyHeaderBody(matchedSeoImportantFacet.headerBody)
      ? matchedSeoImportantFacet.headerBody
      : undefined;
  }

  return categoryDetails?.headerBody;
};
